@if (!giftCard?.value) {
  @if (isModal) {
    <app-empty-state
      imageSrc="/assets/cart-empty.svg"
      titleResource="components.cart-content.empty-cart-title"
      descriptionResource="components.cart-content.empty-cart-description"
    />
  } @else {
    <app-location-schedule />
  }
} @else {
  <div nz-typography class="font-bold !mb-6">{{ 'components.gift-card-content.label-summary' | translate }}</div>
  <div class="space-y-1">
    <div class="flex items-start justify-between gap-4">
      <div nz-typography class="font-semibold">{{ 'components.gift-card-content.label-gift-card' | translate }}</div>
      <div nz-typography class="font-semibold">{{ giftCard.value | customCurrency: location?.currency }}</div>
    </div>

    @if (validityLabel) {
      <div nz-typography nzType="secondary">{{ validityLabel }}</div>
    }
  </div>

  @if (showContinueButton) {
    <div class="mt-6 lg:block" [ngClass]="isModal ? 'block' : 'hidden'">
      <button
        nzBlock
        nz-button
        nzType="primary"
        nzSize="large"
        (click)="onContinue()"
        [disabled]="themeService.getCartBtnDisabled() | async"
      >
        {{ continueBtnLabel }}
      </button>
    </div>

    @if (themeService.getCartBtnInfoText() | async) {
      <div class="mt-4 text-center hidden lg:block text-sm">
        <app-appointment-status-info
          [type]="themeService.getCartBtnInfoType() | async"
          [text]="themeService.getCartBtnInfoText() | async"
        ></app-appointment-status-info>
      </div>
    }
  }
}
